import { Row, Col } from 'react-bootstrap';
import bedIcon from '../assets/images/bed.svg';
import terraceIcon from '../assets/images/balcony.svg';
import bathIcon from '../assets/images/shower.svg';
import carIcon from '../assets/images/car.svg';
import landIcon from '../assets/images/land.svg';
import '../assets/scss/components/featureicons.scss';

const FeatureIcons = ({ text, numOfBedrooms, numOfBathrooms, numOfTerraces, landSize, parking }) => {
    return (
        <Row className="icon-summary d-flex align-items-center">
            {
                numOfBedrooms !== null && numOfBedrooms > 0 && (
                <Col className="icon-item">
                    <img src={ bedIcon } alt="bed icon"/>
                    <p>{ numOfBedrooms } { text && `Bedroom${numOfBedrooms > 1 ? 's' : ''}` }</p>
                </Col>
            )}
            {
                numOfBathrooms !== null && numOfBathrooms > 0 && (
                <Col className="icon-item">
                    <img src={ bathIcon } alt="bath icon"/>
                    <p>{ numOfBathrooms } { text && `Bathroom${numOfBathrooms > 1 ? 's' : ''}` }</p>
                </Col>
            )}
            {
                numOfTerraces !== null && numOfTerraces > 0 && (
                <Col className="icon-item">
                    <img src={ terraceIcon } alt="terrace icon"/>
                    <p>{ numOfTerraces } { text && `Terrace${numOfTerraces > 1 ? 's' : ''}` }</p>
                </Col>
            )}
            {
                landSize !== null && landSize > 0 && (
                <Col className="icon-item">
                    <img src={ landIcon } alt="land size icon"/>
                    <p>{ landSize } sqm</p>
                </Col>
            )}
            {
                parking !== null && parking > 0 && (
                <Col className="icon-item">
                    <img src={ carIcon } alt="parking icon"/>
                    <p>{ parking } { text && `Parking space${parking > 1 ? 's' : ''}` }</p>
                </Col>
            )}
        </Row>
    )
};

export default FeatureIcons;
